import * as type from '../../types/API/itemTypes'

export function getItems(payload: any) {
    return {
        type: type.GET_ITEMS,
        payload: payload
    }
}

export function getPaginatedItems(payload: any) {
    return {
        type: type.GET_ITEMS_PAGINATED,
        payload: payload
    }
}

export function addItems(payload: any) {
    return {
        type: type.ADD_ITEM,
        payload: payload
    }
}

export function editItems(payload: any) {
    return {
        type: type.EDIT_ITEM,
        payload: payload
    }
}

export function deleteItems(payload: any) {
    return {
        type: type.DELETE_ITEM,
        payload: payload
    }
}

export function bulkDeleteItems(payload: any) {
    return {
        type: type.BULK_DELETE_ITEM,
        payload: payload
    }
}

export function bulkUploadItems(payload: any) {
    return {
        type: type.BULK_UPLOAD_ITEM,
        payload: payload
    }
}

export function bulkEditItems(payload: any) {
    return {
        type: type.BULK_EDIT_ITEM,
        payload: payload
    }
}

export function bulkReconcilationItems(payload: any) {
    return {
        type: type.BULK_RECONCILATION_ITEM,
        payload: payload
    }
}

export function bulkUploadAlternateUnit(payload: any) {
    return {
        type: type.BULK_UPLOAD_ALTERNATE_UNIT,
        payload: payload
    }
}

export function bulkStockUpdate(payload: any) {
    return {
        type: type.BULK_STOCK_UPDATE,
        payload: payload
    }
}

export function getLastUpdatedPrice(payload: any) {
    return {
        type: type.GET_LAST_UPDATED_PRICE,
        payload: payload
    }
}